import Paragraph from '@tiptap/extension-paragraph';
import { renderHTMLAttrs, TEMPLATE_VALUE_ATTRIBUTE } from './TemplateValue';
import { mergeAttributes } from '@tiptap/core';
import { parseStyleString, styleToString } from '@/utils/emailHelper';

export const CustomParagraph = Paragraph.extend({
	addAttributes() {
		return {
			...this.parent?.(),
			...TEMPLATE_VALUE_ATTRIBUTE,
			style: {
				default: null,
				parseHTML: (element) => {
					const parsed = parseStyleString(element.getAttribute('style') ?? '');
					delete parsed.lineHeight;
					return styleToString(parsed) || null;
				},
				renderHTML: (attributes) => {
					if (!attributes.style) return {};
					return { style: attributes.style };
				},
			},
		};
	},
	renderHTML({ HTMLAttributes }) {
		return ['p', mergeAttributes(renderHTMLAttrs({ HTMLAttributes, editor: this.editor })), 0];
	},
});
